export default __webpack_public_path__ + "static/media/purpleTheme-boy.a66d8329.svg";